import { selectOfferId } from '.';
import { IAppState } from '../../redux';

export function selectIsNewOffer(state: IAppState): boolean {
  const offerId = selectOfferId(state);

  return !offerId;
}
